/* ===========================================================================
   Naudet (ClaudIA) 2026-08-28 — COMBINAISONS IMPOSSIBLES : re-selection
   automatique d'une valeur disponible.

   LE PROBLEME. Les fiches ont une matrice CREUSE : toutes les combinaisons
   d'options n'existent pas (horloge classique 13 cm = 9 combinaisons pour 8
   variantes ; diagrammes de barographe = 150 combinaisons pour 12 variantes).
   Scenario de Denis, 28/08 : Finition Laiton, puis Cadran Ocean, puis Boitier
   Noir -> la combinaison Noir + Ocean n'existe pas -> la fiche tombe sur
   « non disponible » avec l'image generique. Il faudrait repartir sur une
   valeur autorisee.

   POURQUOI C'EST REVENU. Ce correctif existait depuis le 2026-07-16 et vivait
   dans snippets/variant-main-picker.liquid, branche sur l'evenement de theme
   `variant:update`. La migration Tinker 4.1.4 (publiee le 25/08) a SUPPRIME
   cet evenement : assets/events.js ne declare plus rien de variante, et plus
   aucun fichier du theme ne le diffuse. Le code etait toujours la, identique,
   valide -- et ne s'executait plus. Personne ne voit ce genre de panne : rien
   n'a disparu, rien n'a leve d'erreur.

   CE QUI CHANGE ICI, ET POURQUOI.
   1. Le declencheur n'est plus un NOM D'EVENEMENT mais l'ETAT DU DOM
      (MutationObserver sur data-option-available). Un nom d'evenement de theme
      vient de mourir en silence ; l'etat, lui, ne peut pas mentir. L'evenement
      standard Shopify `shopify:product:select` (module @shopify/events, dispo
      par le CDN, remplacant de `variant:update` en 4.1.4) sert de simple filet.
      ⚠ Il est emis AVANT le re-rendu, pas apres : on ne peut PAS lire les
      disponibilites dans son gestionnaire, seulement planifier un controle.
   2. On corrige UN groupe par passe, puis on laisse le thème re-rendre : les
      disponibilites sont recalculees, et l'observateur rappelle si un autre
      niveau reste faux. C'est ce qui permet de descendre les matrices a TROIS
      niveaux de profondeur, ou une seule correction ne suffit pas.
   3. Plus de stopImmediatePropagation(). En 4.1.1 il evitait le clignotement
      en empechant galerie et prix de peindre l'etat intermediaire. En 4.1.4
      l'evenement precede le fetch : l'arreter casserait le flux natif entier.

   ⚠ Ce fichier est a NOUS. Il ne doit jamais retourner dans un fichier du
   theme : c'est precisement ce qui a coute ce correctif a la migration.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__naudetCombinaisons) return;
  window.__naudetCombinaisons = true;

  /* Garde anti-boucle : au-dela, on laisse vivre l'etat natif plutot que de
     faire tourner la fiche indefiniment. 6 corrections en 5 s laissent la place
     a une matrice a trois niveaux, avec une reprise. */
  var FENETRE_MS = 5000;
  var MAX_CORRECTIONS = 6;
  var compteur = { t: 0, n: 0 };

  function corriger() {
    var coche = document.querySelector(
      'input[type="radio"][data-option-available="false"]:checked'
    );
    if (!coche) return;

    /* Le groupe d'options : le fieldset du selecteur. Volontairement repere
       par le fieldset et non par la balise <variant-picker> — la fenetre
       d'ajout rapide n'a pas forcement la meme enveloppe, et une balise de
       theme peut etre renommee a la prochaine mise a jour. */
    var groupe = coche.closest('fieldset');
    if (!groupe) return;

    var repli = groupe.querySelector(
      'input[type="radio"][data-option-available="true"]:not(:checked)'
    );
    if (!repli) return;

    var t = Date.now();
    if (t - compteur.t > FENETRE_MS) compteur = { t: t, n: 0 };
    if (compteur.n >= MAX_CORRECTIONS) return;
    compteur.n += 1;
    compteur.t = t;

    repli.checked = true;
    repli.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Un seul controle par tache, quel que soit le nombre de mutations. */
  var planifie = false;
  function planifier() {
    if (planifie) return;
    planifie = true;
    setTimeout(function () {
      planifie = false;
      corriger();
    }, 0);
  }

  /* 1. Declencheur principal : l'etat. Le thème remplace (« morph ») le
        selecteur apres chaque choix ; c'est la que les disponibilites bougent. */
  new MutationObserver(planifier).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-option-available']
  });

  /* 2. Filet : evenement standard Shopify. Ne lit rien, planifie seulement. */
  document.addEventListener('shopify:product:select', planifier);

  /* 3. Au chargement : une fiche peut arriver deja sur une combinaison fausse
        (lien partage, retour arriere, ?variant= dans l'URL). */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', corriger);
  } else {
    corriger();
  }
})();
